"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _feedbackExpressions = _interopRequireDefault(require("./feedback-expressions"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _default = exports.default = {
  expressions: _objectSpread(_objectSpread({}, _feedbackExpressions.default), {}, {
    PRIMARY: 'Primary',
    SECONDARY: 'Secondary',
    CONTROL: 'Control',
    OPTION: 'Option',
    DISABLED: 'Disabled',
    ON_CONTRAST: 'OnContrast',
    CHOSEN: 'Chosen',
    COMPLETED: 'Completed'
  }),
  properties: {
    BACKGROUND_COLOR: 'backgroundColor',
    FOREGROUND_COLOR: 'foregroundColor',
    BORDER_COLOR: 'borderColor',
    OUTLINE_COLOR: 'outlineColor',
    SHADOW_COLOR: 'shadowColor',
    FEEDBACK_COLOR: 'feedbackColor',
    ON_FEEDBACK_COLOR: 'onFeedbackColor',
    FIGURE_COLOR: 'figureColor',
    BORDER_RADIUS: 'borderRadius',
    BORDER_WIDTH: 'borderWidth',
    FONT_FAMILY: 'fontFamily',
    FONT_SIZE: 'fontSize',
    FONT_WEIGHT: 'fontWeight',
    LINE_HEIGHT: 'lineHeight',
    TEXT_DECORATION: 'textDecoration',
    DENSITY: 'density',
    FONT_VARIATION: 'fontVariation'
  },
  interactions: {
    FOCUSED: 'Focused',
    GRABBED: 'Grabbed',
    HOVERED: 'Hovered',
    PRESSED: 'Pressed',
    CHOSEN: 'Chosen'
  },
  features: {
    BODY: 'body',
    CONTENT: 'content',
    DESCRIPTION: 'description',
    LABEL: 'label',
    METER: 'meter',
    KNOB: 'knob',
    INDICATOR: 'indicator',
    TITLE: 'title',
    ITEM: 'item',
    BACKDROP: 'backdrop'
  }
};